module.exports = __webpack_public_path__ + "img/ic_logo_declaration.a8d9d1d1.png";